import ItemDetailsSelector from "./itemDetailsSelector";

export { ItemDetailsSelector };
export default ItemDetailsSelector;
